// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"b7ee910e","outerContainer":"_4d0d8883","secondaryToolbar":"_6e88771f","doorHangerRight":"_4a3b5757","toolbarContainer":"f05a935e","toolbarViewerMiddle":"d374fa56","progressBar":"_915896ac","back-to-application":"be4b1df0","root":"_208f5ddc","header":"c822d730","content":"e9d99d36","option":"_2bf83cc9","form":"de7f471c","form--label":"_116f27af","form--subtitle":"_4874fe23","form--text":"cdacdbdb","form--fields":"_50c0bc82","form--btn":"_5a0662ac","disabled":"e549fa53"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientRegistration/PatientRegistrationInfo/index.styl
// module id = 958
// module chunks = 39